import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import uuid from "uuid/v1";
import FilterHolder from "./FilterHolder";
import LanguageTabsForms from "../../../Tabs/LanguageTabsForms";
import Modal from "../../../Modal/Modal";

import { copy, reorder } from "../../../../utils/dragAndDrop";

const grid = 4;

const itemsModules = [
  {
    id: uuid(),
    content: "FilterHolder",
    readableName: "Filterholder",
    type: "item"
  }
];

const getItemStyleType = (isDragging, draggableStyle, selected) => ({
  minHeight: selected.length === 0 && "70px",
  display: selected.length === 0 && "flex",
  justifyContent: selected.length === 0 && "center",
  alignItems: selected.length === 0 && "center",
  padding: selected.length === 0 && 0,
  userSelect: "none",
  // padding: grid * 4,
  border: "1px solid #dae1e7",
  borderRadius: "10px",
  marginTop: "4.5rem",

  // change background colour if dragging
  background: "white",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyleType = isDraggingOver => ({
  background: isDraggingOver ? "black" : "white",
  borderRadius: "10px",
  // padding: grid,
  width: "100%"
});

const initialState = {
  type: "FilterContainer",
  slugName: "filtercontainer",
  components: [],
  filterHeading: {
    en: "",
    es: "",
    ca: "",
    pt: ""
  },
  filterText: {
    en: "",
    es: "",
    ca: "",
    pt: ""
  }
};

const FilterContainer = ({
  toggleRefetch,
  handleReadableNameReusable,
  activeLanguage,
  reusableComponents,
  handlerSetComponents,
  components,
  id,
  reusableComponent,
  reusableComponentSlugname,
  languages,
  handlerSetCarouselComponents,
  selectedOnDragAndDrop
}) => {
  const [state, setState] = useState(initialState);
  const [item] = useState(itemsModules);
  const [selected, setSelected] = useState([]);
  const [isModalOn, setModalState] = useState(false);
  const [carouselIndex, setIndex] = useState();

  const toggleModal = () => {
    setModalState(!isModalOn);
  };

  const handlerSetSliderComponents = (comp, index) => {
    const newSelected = selected;
    newSelected[index].component = comp;
    handlerSetCarouselComponents(newSelected, carouselIndex);
  };

  const handlerSetSlider = (comp, index) => {
    const { component } = comp;
    const newSelected = selected;
    newSelected[index].component = { ...component };
    setSelected(newSelected);
  };

  const handleBlockClose = id => {
    const itemToBeRemovedIndex = selected.map(i => i.id).indexOf(id.toString());
    const arr = [...selected];
    arr.splice(itemToBeRemovedIndex, 1);
    setSelected(arr);
    handlerSetCarouselComponents(arr, carouselIndex);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) {
        handlerSetComponents(
          { component: { key: reusableComponentSlugname } },
          componentIndex
        );
      }
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state
        };
        handlerSetComponents(componentObj, componentIndex);
      }
    }

    if (selectedOnDragAndDrop.length > 0 && components[componentIndex]) {
      setSelected(components[componentIndex].component.components);
    }
  }, [components]);

  const inputObjectHandler = e => {
    const { name, value, lang } = e.target;
    const componentObj = {
      ...state,
      [name]: {
        ...state[name],
        [lang]: value
      }
    };
    setState(componentObj);
  };

  const saveComponentWithFilterText = () => {
    const componentObj = {
      id,
      component: state
    };
    handlerSetComponents(componentObj, carouselIndex);
    toggleModal();
    // setSelected(components[carouselIndex].component.components);
  };

  const copySlide = () => {
    const source = {
      droppableId: "items",
      index: 0
    };

    const destination = {
      droppableId: "selected",
      index: selected.length
    };

    const makeCopy = copy(item, selected, source, destination);
    setSelected(makeCopy);
  };

  const onDragEnd = result => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    switch (source.droppableId) {
      case destination.droppableId: {
        const newOrder = reorder(selected, source.index, destination.index);
        setSelected(newOrder);
        const stateWithRearrangedComponets = { ...state, components: newOrder };
        setState(stateWithRearrangedComponets);
        const componentIndex = components.findIndex(obj => obj.id === id);
        const componentObj = {
          id,
          component: stateWithRearrangedComponets
        };
        handlerSetComponents(componentObj, componentIndex);
        break;
      }
      case "items": {
        const makeCopy = copy(items2, selectedLeft, source, destination);
        setSelected(makeCopy);
        break;
      }
      default: {
        break;
      }
    }
  };
  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <div
          className={`items-center ${
            selected.length > 0
              ? "absolute z-50 right-0 mt-8px mr-4 flex justify-between w-full pl-18"
              : "flex my-8px justify-between mr-5 ml-14"
          }`}
        >
          <button
            type="button"
            onClick={toggleModal}
            className="font-americaMonoBold text-xs pl-10 pr-6 py-2 h-10 rounded-full uppercase bg-greyFilter flex flex-row items-center"
          >
            Set filter text{" "}
            <span className="font-icon icon-add-button text-base font-bold pl-2" />
          </button>
          <button
            type="button"
            onClick={copySlide}
            className="font-americaMonoBold text-xs pl-10 pr-6 py-2 h-10 rounded-full uppercase bg-greyFilter flex flex-row items-center"
          >
            Add filter item{" "}
            <span className="font-icon icon-add-button text-base font-bold pl-2" />
          </button>
        </div>
        <div className="pl-2 w-full h-full">
          <Droppable droppableId="selected">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyleType(snapshot.isDraggingOver)}
              >
                {selected.length > 0 &&
                  selected.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                      activeLanguage={activeLanguage}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={getItemStyleType(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                            selected
                          )}
                          className="relative"
                        >
                          <div
                            className="bg-greyFilterItems text-grey-avatar absolute h-full px-1 z-10 pin-l pin-t flex items-center justify-center "
                            {...provided.dragHandleProps}
                          >
                            =
                          </div>
                          <button
                            className="absolute pin-l pin-t"
                            style={{ marginTop: "-20px", marginLeft: "2px" }}
                            type="button"
                          >
                            <span className="px-4 font-americaMonoBold text-xxs text-white bg-black rounded ml-6.5">
                              {item.readableName}
                            </span>
                          </button>
                          <button
                            className="absolute pin-r pin-t h-4 w-4 flex items-center justify-center bg-black rounded-full"
                            style={{ marginTop: "-20px", marginRight: "2px" }}
                            type="button"
                            onClick={() => {
                              handleBlockClose(item.id);
                            }}
                          >
                            <span className="font-icon icon-close-btn1 text-20 text-white mt-3neg" />
                          </button>
                          {item.content === "FilterHolder" && (
                            <FilterHolder
                              handleReadableNameReusable={
                                handleReadableNameReusable
                              }
                              toggleRefetch={toggleRefetch}
                              reusableComponents={reusableComponents}
                              carouselIndex={carouselIndex}
                              languages={languages}
                              handlerSetSliderComponents={
                                handlerSetSliderComponents
                              }
                              activeLanguage={activeLanguage}
                              handlerSetSlider={handlerSetSlider}
                              id={item.id}
                              components={selected}
                            />
                          )}
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle zIndex="10">
          <>
            <LanguageTabsForms activeTabStyle="tab" tabStyle="active">
              {(activeLang, langs) =>
                langs.map(lang => (
                  <div key={lang} className="mt-0">
                    <div
                      className={`w-full ${
                        activeLang === lang ? "block" : "hidden"
                      } p-7 pt-4 pb-0 rounded-b-lg bg-greyFilter pb-4 mb-4`}
                    >
                      <div className="text-xs font-americaMonoRegular uppercase text-black flex flex-col">
                        Filter Heading
                        <input
                          onChange={inputObjectHandler}
                          className="font-americaMonoRegular rounded-full py-2 px-4 outline-none mt-2 mb-4 text-sm font-americaMonoRegular"
                          name="filterHeading"
                          type="text"
                          lang={lang}
                          value={
                            (state.filterHeading &&
                              state.filterHeading[lang]) ||
                            ""
                          }
                        />
                      </div>
                      <div className="text-xs font-americaMonoRegular uppercase text-black flex flex-col">
                        Filter title
                        <input
                          onChange={inputObjectHandler}
                          className="font-americaMonoRegular rounded-full py-2 px-4 outline-none mt-2 mb-4 text-sm font-americaMonoRegular"
                          name="filterText"
                          type="text"
                          lang={lang}
                          value={
                            (state.filterText && state.filterText[lang]) || ""
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))
              }
            </LanguageTabsForms>
            <button
              className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-greyFilter ml-1 mb-4"
              type="button"
              onClick={saveComponentWithFilterText}
            >
              Save text
            </button>
          </>
        </Modal>
      )}
    </>
  );
};

export default FilterContainer;
